/* Urban47 — barra de escassez da página de produto (snippets/u47-escassez.liquid).
   Números SIMULADOS de propósito (decisão da loja): um número só para a loja toda, calculado pelo RELÓGIO (horário de Brasília).
   A configuração (total, início, fim, baixas, janela, madrugada) vem dos data-* da barra — o lugar para mudar é o snippet.
   A conta é a MESMA do snippet (Liquid), inteira, sem aleatório: mesmo instante = mesmo número em qualquer aparelho.
   Hora: a do aparelho, corrigida pela hora do servidor da loja se a diferença passar de 90 s (mesmo método do bloco de confiança). */
(function () {
  'use strict';
  if (window.U47Escassez) { window.U47Escassez.scan(); return; }

  var SEMANA = 604800, DESLOCA = 356400; /* 356400 = 3 h (UTC-3) + 4 dias (1970-01-05 foi segunda) */
  var ajuste = 0; /* hora do servidor - hora do aparelho (ms) */
  function agora() { return Date.now() + ajuste; }
  function div(a, b) { return Math.floor(a / b); }

  function config(el) {
    var n = function (k, d) { var v = parseInt(el.getAttribute('data-' + k), 10); return isFinite(v) ? v : d; };
    var c = { total: n('total', 2000), inicio: n('inicio', 190), fim: n('fim', 20), baixas: n('baixas', 113), hIni: n('h-ini', 9), hFim: n('h-fim', 23), noite: n('noite', 13) };
    var queda = c.inicio - c.fim, minB = div(queda + 1, 2);
    if (c.baixas < minB) c.baixas = minB;
    if (c.baixas > queda) c.baixas = queda;
    c.queda = queda; c.dois = queda - c.baixas; c.janela = (c.hFim - c.hIni) * 60;
    return c;
  }

  /* Horário (segundos desde segunda 00:00) e tamanho (1 ou 2) de cada baixa da semana `ciclo`. */
  function baixas(c, ciclo) {
    var cm = ciclo % 1000, N = c.baixas, lista = [];
    for (var i = 0; i < N; i++) {
      var d = div(i * 7, N), st = div(d * N + 6, 7), st2 = div((d + 1) * N + 6, 7), cnt = st2 - st, j = i - st, i1 = i + 1;
      var h = (i1 * 7919 + (cm + 3) * 104729 + i1 * i1 * 263) % 997;
      var noite = (i1 * 31 + (cm + 1) * 17) % c.noite === 0, s = d * 86400;
      if (noite) s += (h * 421) % 25200 + 3600;
      else s += (c.hIni * 60 + div((j * 1000 + 100 + h % 800) * c.janela, cnt * 1000)) * 60 + (h * 7) % 60;
      var k = (cm * 7 + i) % N, passo = 1 + div((k + 1) * c.dois, N) - div(k * c.dois, N);
      lista.push({ s: s, passo: passo, noite: noite });
    }
    return lista;
  }

  /* Estado no instante `ms` (UTC): restantes, vendidos, barra (décimos de %) e quando é a próxima mudança (ms). */
  function calcular(c, ms) {
    var l = div(ms, 1000) - DESLOCA, ciclo = div(l, SEMANA), o = l - ciclo * SEMANA, vend = 0, prox = (ciclo + 1) * SEMANA;
    var lista = baixas(c, ciclo);
    for (var i = 0; i < lista.length; i++) {
      if (lista[i].s <= o) vend += lista[i].passo;
      else if (ciclo * SEMANA + lista[i].s < prox) prox = ciclo * SEMANA + lista[i].s;
    }
    var rest = Math.max(c.fim, c.inicio - vend), vendidos = c.total - rest;
    return { ciclo: ciclo, offset: o, restantes: rest, vendidos: vendidos, barra10: div(vendidos * 1000, c.total), proxima: (prox + DESLOCA) * 1000 };
  }

  function milhar(n) { var s = String(n); return n >= 1000 ? div(n, 1000) + '.' + ('00' + (n % 1000)).slice(-3) : s; }
  function lerNum(el) { return el ? parseInt(String(el.textContent).replace(/\D/g, ''), 10) : NaN; }
  var semMovimento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pintarBarra(b, est, animar) {
    var eR = b.querySelector('[data-u47-esc-restantes]'), eV = b.querySelector('[data-u47-esc-vendidos]'), eB = b.querySelector('[data-u47-esc-barra]');
    var largura = div(est.barra10, 10) + '.' + (est.barra10 % 10) + '%';
    var de = lerNum(eR);
    if (!animar || semMovimento || !isFinite(de) || de === est.restantes) {
      if (!animar) b.classList.add('u47-esc--sem-anim');
      if (eR) eR.textContent = String(est.restantes);
      if (eV) eV.textContent = milhar(est.vendidos);
      if (eB) eB.style.width = largura;
      if (!animar) { void b.offsetWidth; b.classList.remove('u47-esc--sem-anim'); }
      return;
    }
    /* baixa com a página aberta: números contam até o valor novo e a barra desliza (transição do CSS) */
    if (eB) eB.style.width = largura;
    var total = est.restantes + est.vendidos, t0 = null, dur = 900;
    var passo = function (t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / dur), r = Math.round(de + (est.restantes - de) * (1 - Math.pow(1 - p, 3)));
      if (eR) eR.textContent = String(r);
      if (eV) eV.textContent = milhar(total - r);
      if (p < 1) requestAnimationFrame(passo);
    };
    requestAnimationFrame(passo);
  }

  var timer = null;
  function pintar(animar) {
    var barras = document.querySelectorAll('[data-u47-esc]'), prox = Infinity;
    for (var i = 0; i < barras.length; i++) {
      var b = barras[i], est = calcular(config(b), agora());
      if (b.getAttribute('data-u47-esc-r') !== String(est.restantes)) {
        pintarBarra(b, est, animar && b.getAttribute('data-u47-esc-r') !== null);
        b.setAttribute('data-u47-esc-r', String(est.restantes));
      }
      if (est.proxima < prox) prox = est.proxima;
    }
    clearTimeout(timer);
    if (prox < Infinity) timer = setTimeout(function () { pintar(true); }, Math.max(1000, Math.min(prox - agora() + 400, 1800000)));
  }

  /* Confere a hora com o servidor ANTES de mexer nos números: até lá fica o número da renderização (feita com a hora do
     servidor). Assim um celular com relógio errado nunca mostra outro número, nem por um instante. Falhou/demorou 4 s?
     Vale o relógio do aparelho. */
  function conferirHora(depois) {
    var feito = false, fim = function () { if (!feito) { feito = true; depois(); } };
    setTimeout(fim, 4000);
    try {
      var t0 = Date.now();
      fetch('/cart.js', { method: 'HEAD', cache: 'no-store', credentials: 'same-origin' }).then(function (r) {
        var t1 = Date.now(), servidor = Date.parse(r.headers.get('date') || '');
        if (servidor) { var diferenca = servidor + 500 - (t0 + t1) / 2; if (Math.abs(diferenca) > 90000) ajuste = diferenca; }
        fim();
      }).catch(fim);
    } catch (e) { fim(); }
  }

  var pronto = false;
  window.U47Escassez = { scan: function () { if (pronto) pintar(false); }, calcular: calcular, config: config, baixas: baixas };
  conferirHora(function () {
    pronto = true; pintar(false);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) pintar(true); });
  });
})();
